import { useGetOne } from 'react-admin';

export const AUDIT_LOG_QUERY = 'audit-logs';

export function useAuditLog(auditLogId) {
  //to-do: implement select when we upgrade to react admin 4.0 and actually use react-query

  return useGetOne(AUDIT_LOG_QUERY, { id: `${auditLogId}?expand=true` });
}
